<div class="info-box">
    @for (item of configuration.items; track item) { @switch (item.type) { @case
    ('title') {
        @let title = getTitle(item.data);
    <div class="title">
        {{ title.content }}
    </div>
    } @case ('body') {
        @let body = getBody(item.data);
    <div class="body">
        {{ body.content }}
    </div>
    } @case ('html') {
        @let html = getHtml(item.data);
    <div class="body">
        <ng-container
            *ngTemplateOutlet="
                buildHtml;
                context: { $implicit: html.content }
            "
        ></ng-container>
    </div>
    } @case ('phone') {
        @let phone = getPhone(item.data);
    <div class="contact">
        <div class="label">{{ phone.label }}</div>
        <div class="data">
            <a href="tel:{{ phone.tel }}">{{ phone.display }}</a>
        </div>
    </div>
    } @case ('email') {
        @let email = getEmail(item.data);
    <div class="contact">
        <div class="label">{{ email.label }}</div>
        <div class="data">
            <a href="mailto:{{ email.address }}">{{ email.address }}</a>
        </div>
    </div>
    } @case ('button') {
        @let button = getButton(item.data);
    <div class="button">
        <a
            [href]="button.href"
            [target]="!!button.target ? button.target : ''"
            >{{ button.label }}</a
        >
    </div>
    } @case ('spacer') {
    <div class="spacer">&nbsp;</div>
    } } }
</div>

<ng-template #buildHtml let-items>
    @for (item of items; track item) {
    <ng-container
        *ngTemplateOutlet="
            (item | hasProp : 'type') ? tagBuilder : justText;
            context: { $implicit: item }
        "
    >
    </ng-container>
    }
</ng-template>

<ng-template #tagBuilder let-item>
    @switch (item.type) { @case ('a') {
    <a [href]="item.href">
        {{ item.display }}
    </a>
    } }
</ng-template>

<ng-template #justText let-text>
    <span [innerHtml]="text"></span>
</ng-template>
